export default __webpack_public_path__ + "static/media/counter-bg.b6fc9794.jpg";